"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Rows = exports.RowsStyle = void 0;
const two_js_1 = __importDefault(require("two.js"));
const BallScrewElement_1 = require("./BallScrewElement");
/**
 * Define a row style
 * normal: for all images lines
 * thread: for threads
 * axis: for object axis
 * hidden: for hidden parts in object
 */
var RowsStyle;
(function (RowsStyle) {
    RowsStyle[RowsStyle["Normal"] = 0] = "Normal";
    RowsStyle[RowsStyle["Thread"] = 1] = "Thread";
    RowsStyle[RowsStyle["Axis"] = 2] = "Axis";
    RowsStyle[RowsStyle["Hidden"] = 3] = "Hidden";
})(RowsStyle = exports.RowsStyle || (exports.RowsStyle = {}));
/**
 * Class to draw a single line
 */
class Rows {
    /**
     * Method to draw a line in a different style
     * @param two
     * @param startX
     * @param startY
     * @param endX
     * @param endY
     * @param style
     */
    static draw(two, startX, startY, endX, endY, style = RowsStyle.Normal) {
        const line = two.makeLine(startX, startY, endX, endY);
        line.linewidth = style === RowsStyle.Thread ? 0.7 : 1;
        line.dashes = this.getDashesForStyle(style);
        line.noFill();
        return line;
    }
    static getDashesForStyle(style) {
        switch (style) {
            case RowsStyle.Axis: {
                return [50, 7, 9, 7];
            }
            case RowsStyle.Normal: {
                return [];
            }
            case RowsStyle.Hidden: {
                return [5, 3];
            }
            case RowsStyle.Thread: {
                return [];
            }
        }
    }
    static makeArrow(direction = "up", size = 7, fill = true) {
        let path = null;
        if (direction === "down") {
            path = new two_js_1.default.Path([
                new two_js_1.default.Anchor(size / 2, size / 2, 0, 0, 0, 0, two_js_1.default.Commands.line),
                new two_js_1.default.Anchor(size, size + (size / 2), 0, 0, 0, 0, two_js_1.default.Commands.line),
                new two_js_1.default.Anchor(size + (size / 2), size / 2, 0, 0, 0, 0, two_js_1.default.Commands.line),
            ], true, false, true);
        }
        else if (direction === "up") {
            path = new two_js_1.default.Path([
                new two_js_1.default.Anchor(size / 2, size + (size / 2), 0, 0, 0, 0, two_js_1.default.Commands.line),
                new two_js_1.default.Anchor(size, size / 2, 0, 0, 0, 0, two_js_1.default.Commands.line),
                new two_js_1.default.Anchor(size + (size / 2), size + (size / 2), 0, 0, 0, 0, two_js_1.default.Commands.line),
            ], true, false, true);
        }
        else if (direction === "left") {
            path = new two_js_1.default.Path([
                new two_js_1.default.Anchor(size / 2, size, 0, 0, 0, 0, two_js_1.default.Commands.line),
                new two_js_1.default.Anchor(size + (size / 2), size + (size / 2), 0, 0, 0, 0, two_js_1.default.Commands.line),
                new two_js_1.default.Anchor(size + (size / 2), size / 2, 0, 0, 0, 0, two_js_1.default.Commands.line),
            ], true, false, true);
        }
        else if (direction === "right") {
            path = new two_js_1.default.Path([
                new two_js_1.default.Anchor(size / 2, size / 2, 0, 0, 0, 0, two_js_1.default.Commands.line),
                new two_js_1.default.Anchor(size / 2, size + (size / 2), 0, 0, 0, 0, two_js_1.default.Commands.line),
                new two_js_1.default.Anchor(size + (size / 2), size, 0, 0, 0, 0, two_js_1.default.Commands.line),
            ], true, false, true);
        }
        path.fill = BallScrewElement_1.BallScrewElement.COLORQUOTE;
        path.noStroke();
        return path;
    }
}
exports.Rows = Rows;
